'use es6';

import { useSelector } from 'react-redux';
import { calculateUnseenThreadsCount } from '../../threads/selectors/calculateUnseenThreadsCount';
import { getColoring } from '../../selectors/widgetDataSelectors/getColoring';
import { getIsOpen } from '../../selectors/getIsOpen';
import { getShowLauncherBadge } from '../../visitor-widget/selectors/getShowLauncherBadge';
import Launcher from 'conversations-visitor-experience-components/visitor-widget/Launcher';
import { jsx as _jsx } from "react/jsx-runtime";
const useComponent = () => {
  const badgeNumber = useSelector(calculateUnseenThreadsCount);
  const coloring = useSelector(getColoring);
  const open = useSelector(getIsOpen);
  const showBadge = useSelector(getShowLauncherBadge);
  return {
    badgeNumber,
    coloring,
    open,
    showBadge
  };
};
const LauncherContainer = props => {
  const componentProps = useComponent();
  return /*#__PURE__*/_jsx(Launcher, Object.assign({}, props, componentProps));
};
LauncherContainer.displayName = 'LauncherContainer';
export default LauncherContainer;